import React, { useState } from 'react';

import { List, Datagrid, TextField, DeleteButton, Edit, TextInput, Button, Create, SimpleForm, TopToolbar, FormTab, TabbedForm, FormDataConsumer, required, FunctionField, ResourceContextProvider, useCreate, useRefresh, FormWithRedirect, Toolbar, SaveButton, useNotify, useRedirect, DateField, Filter, downloadCSV, DateInput } from 'react-admin';import jsonExport from 'jsonexport/dist';

import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';

import { makeStyles } from '@material-ui/core/styles';

import { useTranslate  } from '../common/language';

import Typography from '@mui/material/Typography';


import { TextFieldShow } from '../components/TextFieldShow';

import Grid from '@mui/material/Grid';
import Avatar from '@mui/material/Avatar';
import IconContentAdd from '@material-ui/icons/Add';
import IconCancel from '@material-ui/icons/Cancel';
import GavelIcon from '@material-ui/icons/Gavel';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';

import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import { dateOnlyToCatalan, headersAPIDocAuth } from './../common/utils';  
import { apiUrl } from './../common/constants';

import { ExportButton } from './../components/ExportButton';

import { Link } from 'react-router-dom';

import { validateMaxLength } from './../components/Validator';

const bookingPdfUrl = record => record ? `${apiUrl}/tickets_booking/${record.id}/pdf` : null;

const DownloadBookingPdfButton = ({ record }) => {
  const translate = useTranslate();

  const handleClick = async event => {
    event.stopPropagation();
    const url = bookingPdfUrl(record);
    if (!url) return;

    const response = await fetch(url, { headers: headersAPIDocAuth() });
    const blob = await response.blob();
    const href = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = href;
    link.download = 'entrades.pdf';
    link.click();
    window.URL.revokeObjectURL(href);
  };

  return record ? (
    <Button onClick={handleClick} label="" title={translate('tickets_booking.download_pdf')}>
      <PictureAsPdfIcon />
    </Button>
  ) : null;
};

export const TicketsBookingList = (props) => {
  const translate = useTranslate();  
    
  const basePath='/tickets_booking';
  const resource = 'tickets_booking';
  const listFilter = {
    associations_id: localStorage.getItem('associations_id'),
    ...(props.users_id ? { users_id: props.users_id } : {})
  };
    
  return (
    <ResourceContextProvider value={resource}>
      <List 
        basePath={basePath}   
        filter={listFilter}
        actions={props.show ?  <span/> : <ListActions />}    
        empty={props.show ?  <span/> : <ListActions />}        
        bulkActionButtons={false}          
        perPage={1000}   
        pagination={false}
        sort={{ field: 'id', order: 'ASC' }} 
        label=""  
        title=""  
        resource={resource}
        filters={props.show ?  <span/> : <MyFilter />} 
        filterDefaultValues={ { q: "" }}
      >        
        <Datagrid 
          rowClick={props.show ? null : 'edit'}
          expand={<TicketsBookingDetails />} >  
          <Avatar><GavelIcon/></Avatar>                                  
          <TextField source="events_sessions_id" label={translate('tickets_booking.events_sessions_id')} sortable={false} />  
          <TextField source="users_id" label={translate('tickets_booking.users_id')} sortable={false} />  
          <TextField source="first_name" label={translate('tickets_booking.first_name')} sortable={false} />  
          <TextField source="last_name_1" label={translate('tickets_booking.last_name_1')} sortable={false} />  
          <TextField source="last_name_2" label={translate('tickets_booking.last_name_2')} sortable={false} />  
          <TextField source="phone" label={translate('tickets_booking.phone')} sortable={false} />  
          <TextField source="email" label={translate('tickets_booking.email')} sortable={false} />  
          <DateField source="booking_date_time" label={translate('tickets_booking.booking_date_time')} sortable={false} />  
          <TextField source="amount_total" label={translate('tickets_booking.amount_total')} sortable={false} />  
          <TextField source="payment_status" label={translate('tickets_booking.payment_status')} sortable={false} />  
          <DateField source="payment_date" label={translate('tickets_booking.payment_date')} sortable={false} />  
          <DateField source="created_at" label={translate('tickets_booking.created_at')} sortable={false} />  
          <DateField source="updated_at" label={translate('tickets_booking.updated_at')} sortable={false} />  
          <FunctionField label={translate('tickets_booking.download_pdf')} sortable={false} render={record => <DownloadBookingPdfButton record={record} />} />
        </Datagrid>        
      </List>
    </ResourceContextProvider>
  );
};

const MyFilter = (props) => {
    const translate = useTranslate(); 
    return (
    <Filter {...props}>         
        <TextInput label={translate('common.search')} source="q" alwaysOn validate={[validateMaxLength(50,translate('common.validation.maxLength'))]} resettable />    
    </Filter>
);
};

export const TicketsBookingDetails = ({ id, record, resource, ...props }) => {
  const translate = useTranslate(); 
        
  return (
    <div className="usersClassroomsExpand">        
      <Grid container spacing={2}>
        <Grid item xs={4}>   
          <TextFieldShow source={record.events_sessions_id} label={translate('tickets_booking.events_sessions_id')} />
        </Grid> 
        <Grid item xs={4}>   
          <TextFieldShow source={record.users_id} label={translate('tickets_booking.users_id')} />
        </Grid> 
        <Grid item xs={4}>   
          <TextFieldShow source={record.first_name} label={translate('tickets_booking.first_name')} />
        </Grid> 
        <Grid item xs={4}>   
          <TextFieldShow source={record.last_name_1} label={translate('tickets_booking.last_name_1')} />
        </Grid> 
        <Grid item xs={4}>   
          <TextFieldShow source={record.last_name_2} label={translate('tickets_booking.last_name_2')} />
        </Grid> 
        <Grid item xs={4}>   
          <TextFieldShow source={record.phone} label={translate('tickets_booking.phone')} />
        </Grid> 
        <Grid item xs={4}>   
          <TextFieldShow source={record.email} label={translate('tickets_booking.email')} />
        </Grid> 
        <Grid item xs={4}>   
          <TextFieldShow source={dateOnlyToCatalan(record.booking_date_time)} label={translate('tickets_booking.booking_date_time')} />
        </Grid> 
        <Grid item xs={4}>   
          <TextFieldShow source={record.amount_total} label={translate('tickets_booking.amount_total')} />
        </Grid> 
        <Grid item xs={4}>   
          <TextFieldShow source={record.payment_status} label={translate('tickets_booking.payment_status')} />
        </Grid> 
        <Grid item xs={4}>   
          <TextFieldShow source={dateOnlyToCatalan(record.payment_date)} label={translate('tickets_booking.payment_date')} />
        </Grid> 
        <Grid item xs={4}>   
          <TextFieldShow source={dateOnlyToCatalan(record.created_at)} label={translate('tickets_booking.created_at')} />
        </Grid> 
        <Grid item xs={4}>   
          <TextFieldShow source={dateOnlyToCatalan(record.updated_at)} label={translate('tickets_booking.updated_at')} />
        </Grid> 
      </Grid>
      
    </div>
  );
};

const exporter = (items, translate, notify) => {
    
  const itemsForExport = items.map(item => {
    var itemForExport = {
        id: item.id,
        events_sessions_id: item.events_sessions_id,
        users_id: item.users_id,
        first_name: item.first_name,
        last_name_1: item.last_name_1,
        last_name_2: item.last_name_2,
        phone: item.phone,
        email: item.email,
        booking_date_time: dateOnlyToCatalan(item.booking_date_time),
        amount_total: item.amount_total,
        payment_status: item.payment_status,
        payment_date: dateOnlyToCatalan(item.payment_date),
        created_at: dateOnlyToCatalan(item.created_at),
        updated_at: dateOnlyToCatalan(item.updated_at),
    };
    return itemForExport;
  });
  jsonExport(itemsForExport, {
    headers: ['id','events_sessions_id'
,'users_id'
,'first_name'
,'last_name_1'
,'last_name_2'
,'phone'
,'email'
,'booking_date_time'
,'amount_total'
,'payment_status'
,'payment_date'
,'created_at'
,'updated_at'
],
    rename: [translate('common.id'),translate('tickets_booking.events_sessions_id'),translate('tickets_booking.users_id'),translate('tickets_booking.first_name'),translate('tickets_booking.last_name_1'),translate('tickets_booking.last_name_2'),translate('tickets_booking.phone'),translate('tickets_booking.email'),translate('tickets_booking.booking_date_time'),translate('tickets_booking.amount_total'),translate('tickets_booking.payment_status'),translate('tickets_booking.payment_date'),translate('tickets_booking.created_at'),translate('tickets_booking.updated_at')],        
        
  }, (err, csv) => {
    const csv_new = '\uFEFF' + csv;
    downloadCSV(csv_new, translate('tickets_booking.exporter_file_name') ); 
    notify(translate('common.download_ok'),"success");
  });
};


const ListActions = (props) => {
    const translate = useTranslate(); 
    
    let filterExport = { 
        associations_id: localStorage.getItem('associations_id'),        
        q: props.filterValues && props.filterValues.q ? props.filterValues.q : ''
    };
    
    return (
    <TopToolbar>     
        <MyCreateButton {...props} />    
        <ExportButton maxResults="100000" filterValues={filterExport} alwaysEnabled={false} exporter={exporter} sort={{ field: 'id', order: 'DESC' }} /> 
    </TopToolbar>
    );
};

export const MyCreateButton = ({ users_id , ...props }) => {

  const [showDialog, setShowDialog] = useState(false);
  const [create, { loading }] = useCreate('tickets_booking');
  const notify = useNotify();
  const refresh = useRefresh();    
  const translate = useTranslate();  
  const redirect = useRedirect();
        
  const handleClick = () => {
    setShowDialog(true);
  };

  const handleCloseClick = () => {
    setShowDialog(false);
  };

  const handleSubmit = async values => {
    create(            
      { payload: { data: values } },
      {
        onSuccess: ({ data }) => {                    
          redirect('/tickets_booking/' + data.id);
        
        },
        onFailure: ( error ) => {
          notify( error.message , 'error');
        }
      }
    );
  };
    
  return (
    <>            
      <Button onClick={handleClick} label={translate('tickets_booking.create')}>
        <IconContentAdd />                
      </Button>

      <Dialog
        fullWidth
        open={showDialog}
        onClose={handleCloseClick}
        aria-label={translate('tickets_booking.create')}
      >
        <DialogTitle>{translate('tickets_booking.create')}</DialogTitle>

        <FormWithRedirect
          save={handleSubmit}
          initialValues={{ associations_id: localStorage.getItem('associations_id') }}
          render={({
            handleSubmitWithRedirect,
            pristine,
            saving
          }) => (
            <>
              <DialogContent>
                <Grid container spacing={1}>                                     
                  <Grid item xs={12}>                                               
                    <TextInput fullWidth source="name" label={translate('common.name')} validate={[required(),validateMaxLength(255,translate('common.validation.maxLength'))]} />
                  </Grid>
                </Grid> 
              </DialogContent>
              <DialogActions>
                <Button label="ra.action.cancel" onClick={handleCloseClick} disabled={loading} >
                  <IconCancel />
                </Button>
                <SaveButton
                  handleSubmitWithRedirect={
                    handleSubmitWithRedirect
                  }
                  pristine={pristine}
                  saving={saving}
                  disabled={loading}
                />
              </DialogActions>
            </>
          )}
        />
      </Dialog>
    </>
  );
};

const MyActions = ({ basePath, data, resource }) => {

  const translate = useTranslate();   
    
  let linkBack = '/tickets_booking';
        
  return (
    <>
      <TopToolbar>
        <Grid container spacing={2}>
          <Grid item xs={12}>   
            <div style={{
              display: 'flex',
              alignItems: 'center',
              flexWrap: 'wrap',
            }}>
              <Link
                to={linkBack}
                className=""
              >
                <ArrowBackIosNewIcon className="mr-2" />                        
              </Link>
              <Typography variant="h5" className="grey8">
                {data && data.name ? data.name : null}                    
              </Typography>
            </div>  
                
          </Grid>
        </Grid> 
      </TopToolbar>
    </>
  );
};


export const TicketsBookingEdit  = ({ id, ...props }) => {

  const translate = useTranslate();        
  const classes = useStyles();
  const notify = useNotify();
  const refresh = useRefresh();
  const redirect = useRedirect();

  let strRedirect =  `/tickets_booking/${id}`;    
    
  const onSuccess = ({ data }) => {
    notify(translate('common.notification.updated'));        
    redirect('/tickets_booking');        
  };
        
  return (

    <Edit 
      title={<ElementTitle {...props}  />} 
      {...props} 
      id={id}
      mutationMode="pessimistic"
      actions={<MyActions {...props} />}
      onSuccess={onSuccess}   
    >
        
      <TabbedForm        
        toolbar={<FormToolbar />}
      >    
        <FormTab
          label={translate('classrooms.data')}
          contentClassName={classes.tab}
          path="" 
                
        > 
               
          <FormDataConsumer>
            {({ formData, ...rest }) => 
              <>                              
                <br/>
                <Grid container spacing={2}>
                  <Grid item xs={3}>   
            <TextInput fullWidth source="events_sessions_id" label={translate('tickets_booking.events_sessions_id')} validate={[validateMaxLength(255,translate('common.validation.maxLength'))]} />
                  </Grid> 
                  <Grid item xs={3}>   
            <TextInput fullWidth source="users_id" label={translate('tickets_booking.users_id')} validate={[validateMaxLength(255,translate('common.validation.maxLength'))]} />
                  </Grid> 
                  <Grid item xs={3}>   
            <TextInput fullWidth source="first_name" label={translate('tickets_booking.first_name')} validate={[validateMaxLength(255,translate('common.validation.maxLength'))]} />
                  </Grid> 
                  <Grid item xs={3}>   
            <TextInput fullWidth source="last_name_1" label={translate('tickets_booking.last_name_1')} validate={[validateMaxLength(255,translate('common.validation.maxLength'))]} />
                  </Grid> 
                  <Grid item xs={3}>   
            <TextInput fullWidth source="last_name_2" label={translate('tickets_booking.last_name_2')} validate={[validateMaxLength(255,translate('common.validation.maxLength'))]} />
                  </Grid> 
                  <Grid item xs={3}>   
            <TextInput fullWidth source="phone" label={translate('tickets_booking.phone')} validate={[validateMaxLength(255,translate('common.validation.maxLength'))]} />
                  </Grid> 
                  <Grid item xs={3}>   
            <TextInput fullWidth source="email" label={translate('tickets_booking.email')} validate={[validateMaxLength(255,translate('common.validation.maxLength'))]} />
                  </Grid> 
                  <Grid item xs={3}>   
            <DateInput fullWidth source="booking_date_time" label={translate('tickets_booking.booking_date_time')}  />
                  </Grid> 
                  <Grid item xs={3}>   
            <TextInput fullWidth source="amount_total" label={translate('tickets_booking.amount_total')} validate={[validateMaxLength(255,translate('common.validation.maxLength'))]} />
                  </Grid> 
                  <Grid item xs={3}>   
            <TextInput fullWidth source="payment_status" label={translate('tickets_booking.payment_status')} validate={[validateMaxLength(255,translate('common.validation.maxLength'))]} />
                  </Grid> 
                  <Grid item xs={3}>   
            <DateInput fullWidth source="payment_date" label={translate('tickets_booking.payment_date')}  />
                  </Grid> 
                  <Grid item xs={3}>   
            <DateInput fullWidth source="created_at" label={translate('tickets_booking.created_at')}  />
                  </Grid> 
                  <Grid item xs={3}>   
            <DateInput fullWidth source="updated_at" label={translate('tickets_booking.updated_at')}  />
                  </Grid> 
                  <Grid item xs={12}>   
                  </Grid> 
                </Grid>                                

              </>
            }
          </FormDataConsumer>

        </FormTab> 
        
    
      </TabbedForm>
    </Edit>
  );
};

const ElementTitle = ({ record, ...props }) => {    
  const translate = useTranslate(); 
  return (<span>{translate('common.edit')} {record ? `"${record.name}"` : ''}</span>);
};

const FormToolbar = ({ id , ...props }) => {
    
  let redirect = '/tickets_booking';
    
    
  return (
    <Toolbar {...props} className="user_form_toolbar" >
      <SaveButton />
      <DeleteButton redirect={redirect} mutationMode="pessimistic" />
    </Toolbar>
  );
};

const useStyles = makeStyles({
  comment: {
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  tab: {
    maxWidth: '100%',
    display: 'block',
  },
});






export const TicketsBookingCreate  = ({ id, ...props }) => {

  const translate = useTranslate();   
  const [info, setInfo] = useState();
    
  return (

    <Create {...props} >
      <SimpleForm 
        initialValues={{ associations_id: localStorage.getItem('associations_id') }}
        redirect="list"
      >                
        <Grid container spacing={2}>
          <Grid item xs={12}>                    
            <Typography variant="h5" className="grey">{translate('tickets_booking.create')}</Typography>
          </Grid>  
          <Grid item xs={11}>                    
            <TextInput fullWidth source="name" label={translate('common.name')} validate={[required(),validateMaxLength(255,translate('common.validation.maxLength'))]} />
          </Grid>          
        </Grid>   

      </SimpleForm> 
    </Create>
  );
};
